// extracted by mini-css-extract-plugin
export default {"invalidInput":"ErrorLabel_invalidInput__YHtve","yellowLabel":"ErrorLabel_yellowLabel__mTAFA","greenLabel":"ErrorLabel_greenLabel__OHqCm"};